import { render, staticRenderFns } from "./PurchaseDone.vue?vue&type=template&id=01b39ffd&"
import script from "./PurchaseDone.vue?vue&type=script&lang=js&"
export * from "./PurchaseDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports